<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: "app"
};
</script>

<style lang="scss">
// CoreUI Icons Set
@import "~@coreui/icons/css/coreui-icons.min.css";
/* Import Font Awesome Icons Set */
$fa-font-path: "~font-awesome/fonts/";
@import "~font-awesome/scss/font-awesome.scss";
/* Import Simple Line Icons Set */
$simple-line-font-path: "~simple-line-icons/fonts/";
@import "~simple-line-icons/scss/simple-line-icons.scss";

@import "assets/vendors/flaticon/flaticon.css";
@import "assets/vendors/flaticon2/flaticon.css";

@import "assets/vendors/line-awesome/css/line-awesome.css";
/* Import Flag Icons Set */
@import "~flag-icon-css/css/flag-icon.min.css";
// nprogress
@import "~nprogress/nprogress.css";
/* Import Bootstrap Vue Styles */
@import "~bootstrap-vue/dist/bootstrap-vue.css";
// Import Main styles for this application
//@import "assets/scss/style";
@import "assets/metronic/theme/admin/style";
@import "assets/metronic/custom";
</style>

